import { addDoc, collection, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { serviceResponse } from "./common";
import { db } from "./connect";

export interface Position {
    id: string;
    name: string;
    createAt: string;
    isActive: boolean;
}

const collectionName = "positions";

const createPosition = async (name: string) => {
    try {
        if (!name) {
            return serviceResponse.emptyFields;
        }

        const position: Position = {
            name: name.toLowerCase(),
            id: "",
            createAt: new Date().toJSON(),
            isActive: true
        }

        const docRef = collection(db, collectionName);
        await addDoc(docRef, position);
        return;
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const getPositions = async () => {
    try {
        const docRef = collection(db, collectionName);
        const docs = await getDocs(docRef);

        if (docs.empty) {
            return serviceResponse.notContent;
        }

        return docs.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const updatePosition = async (position: Position) => {
    try {
        if (!position.id) {
            return serviceResponse.emptyFields;
        }

        const docRef = doc(db, collectionName, position.id);
        await updateDoc(docRef, { ...position });
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const togglePositionStatus = async (id: string, isActive: boolean) => {
    try {
        if (!id) {
            return serviceResponse.emptyFields;
        }

        const docRef = doc(db, collectionName, id);
        await updateDoc(docRef, { isActive: !isActive });
        return;
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const isPositionNameAvailable = async (name: string) => {
    try {
        if (!name) {
            return serviceResponse.emptyFields;
        }

        const docRef = collection(db, collectionName);
        const filter = query(docRef, where("name", "==", name));
        const req = await getDocs(filter);

        if (req.empty) {
            return serviceResponse.ok;
        }
        return serviceResponse.actionDenied;
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

export {
    createPosition,
    getPositions,
    updatePosition,
    togglePositionStatus,
    isPositionNameAvailable
}